import React from 'react';
import {eVoucherTypes} from 'data/enums/products';
import {Switch, Case} from "react-if";
import FieldTypeShop from './components/fieldTypeShop';
import FieldTypeShops from "./components/fieldTypeShops";
import FieldTypeRestaurant from "./components/fieldTypeRestaurant";
import FieldTypeRestaurants from "./components/fieldTypeRestaurants";
import FieldTypeExperience from "./components/fieldTypeExperience";
import FieldTypeExperiences from "./components/fieldTypeExperiences";

export interface IVoucherDetails {
  type: eVoucherTypes;

}

interface ICustomFieldsTypeSwitchProps {
  values: IVoucherDetails;
}

const CustomFieldsTypeSwitch = (props: ICustomFieldsTypeSwitchProps) => {
  return (
    <Switch>
      <Case condition={props.values.type === eVoucherTypes.restaurant}>{() => <FieldTypeRestaurant/>}</Case>
      <Case condition={props.values.type === eVoucherTypes.restaurants}>{() => <FieldTypeRestaurants/>}</Case>
      <Case condition={props.values.type === eVoucherTypes.shop}>{() => <FieldTypeShop/>}</Case>
      <Case condition={props.values.type === eVoucherTypes.shops}>{() => <FieldTypeShops/>}</Case>
      <Case condition={props.values.type === eVoucherTypes.experience}>{() => <FieldTypeExperience/>}</Case>
      <Case condition={props.values.type === eVoucherTypes.experiences}>{() => <FieldTypeExperiences/>}</Case>
    </Switch>
  );
};

CustomFieldsTypeSwitch.defaultProps = {
  values: {}
};

export default React.memo(CustomFieldsTypeSwitch);
